// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { css } from "styled-components";

export const popoverStyles = () => {
    return css`
        background-color: ${getColor("common.background")};
        box-shadow: ${getProp("theme.shadows.light60")};
        color: inherit;
    `;
};
